import { createFileRoute } from '@tanstack/react-router'
import { AgentMemoryPage } from '../../../modules/agent-workspace'

export const Route = createFileRoute('/_authed/agent-workspace/memory')({
  component: AgentMemoryPage,
})
